
import "./HealthTwoPrescriptions.scss";

const HealthTwoPrescriptions = () => {
  return (
    <div className="health-two-prescription-options">
     
      <div className="option upload">
        <div className="inner-box">
         
          <div className="text-container">
            <h3>Upload prescription to place order</h3>
            <p>
              Upload only .jpg, .png, or .pdf files
              <br />
              Size limit is 15 MB
            </p>
          </div>

          <div className="icon-section">
            <img
              src="/assets/img/health/healthTwo/medical-check.png"
              alt="Prescription Icon"
            />
          </div>
        </div>

       
        <div className="buttons-container">
          <button className="primary">Order Via Prescription</button>
          <a href="/" className="link">
            How to order?
          </a>
        </div>
      </div>

      <div className="option consult">
        <div className="content">
          <h3>Don’t have a Prescription?</h3>
          <p>
            Upload only .jpg, .png, or .pdf files
            <br />
            Size limit is 15 MB
          </p>
          <button className="secondary">Start Consultations</button>
        </div>
        <div className="doctor-img">
          <img src="/assets/img/health/healthTwo/portrait-smiling-young-woman-doctor-healthcare-medical-worker-pointing-fingers-left-showing-clini-removebg-preview-removebg-preview.png" alt="Doctor" />
        </div>
      </div>
    </div>
  );
};

export default HealthTwoPrescriptions;
